// extracted by mini-css-extract-plugin
module.exports = {"TooltipContent__tooltip-content__2VJ2d":"TooltipContent__tooltip-content__2VJ2d"};